import { Rx } from "subtree.js/core";
import { type FormStatus, idleForm } from "../../../../core/primitives/load-status";
import {
  EMPTY_PROFILE,
  type ProfileDraft,
  type ProfileErrors,
  type ProfileField,
} from "../../../../core/primitives/store-profile";

export class ProfileSectionState {
  readonly draft = new Rx<ProfileDraft>(EMPTY_PROFILE);
  readonly errors = new Rx<ProfileErrors>({});
  readonly form = new Rx<FormStatus>(idleForm);
  /** A shop that has claimed a hosted page can no longer clear its description. */
  readonly hostsPage = new Rx(false);
}

export abstract class ProfileSectionActions {
  abstract setField(field: ProfileField, value: string): void;
  abstract save(): Promise<void>;
}
